import help from './help';

export default help;



// WEBPACK FOOTER //
// ./src/store/reducers/help/index.js